import "../../App.css";
import React from "react";
import Veeners from '../Veeners';
import CONTACT_US from '../footer';
import Accordian from '../../accordian/accordian'
import ScrollArrow from '../ScrollUp';
import BackBtn from '../BackBtn';


function Veeners_Page() {
    return(
    <>
        <Veeners/>
        <Accordian
         title="Am I a candidate of dental veneers or laminates" 
         content="  Dental facade might be appropriate for you and are equivalent if you are searching for an option in contrast to crowns and tops. Facade can encourage you if you have holes between your teeth or teeth that are broken, chipped, unpredictably formed or misaligned. To discover more about whether dental facade are ideal for you, contact us soon!"
       />
       <Accordian
         title=" What should I expect when I get my dental veneers" 
         content="  Before dental facade can be set on the teeth, the surface of the teeth must be set up for holding. We will buff away around a portion of a millimetre from the surface of the teeth and your façade will be prepared in a dental lab. Later, you'll be requested to come back to have them fitted, reinforced and balanced for shape and shading."
       />
       <Accordian
         title=" Will I need to follow any post treatment care instructions" 
         content="< There is no extraordinary consideration required for dental facade, and ordinary brushing and flossing can be continued promptly. Since facade are typically put throughout two arrangements, it is ordinary to encounter some sensuality between the first and second visit when the teeth have been lessened in anticipation of holding."
       />
    <BackBtn/>
    <CONTACT_US/>
    <ScrollArrow/>

    </>
    )
}
export default Veeners_Page;